<template>
    <div id="all">
      <van-icon @click="toHome" class="icon" size="30" color='rgba(255,255,255,0.6)' name="arrow-left" />
      <div>{{title}}</div>
      <img @click="$emit('filtrate')" src="@/assets/img/details/sx.png" alt="">
    </div>
</template>

<script>
import { Icon } from 'vant';
export default {
     name:'Header',
    components: {
      'van-icon':Icon
    },
    props: {
      title:{
        type:String
      }
    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      // 回到首页
      toHome () {
          this.$router.push('/')
          sessionStorage.removeItem('paramStr')
          sessionStorage.removeItem('Filtrate')
      }
    },
};
</script>

<style scoped lang="scss">
#all{
  width: 100%;
  height: 131px;
  background-image: linear-gradient(#433AC7, #1C72F3);
  display: flex;
  justify-content:space-between;
  position: fixed;
  top: 0;
  z-index: 9;
  & .icon{
    line-height: 131px;
    margin-left: 20px;
  }
  & div{
    line-height: 131px;
    font-size: 18px;
    color: #fff;
    position: relative;
    right: 10px;
  }
  & img{
    position: relative;
    top: 54px;
    width: 25px;
    height: 25px;
    right: 20px;
  }
}
</style>
